import React, { useState, useEffect, useRef, useCallback } from "react";
import WelDataService from "../services/WelService";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const WelList = (props) => {
  const [wel, setWel] = useState([]);
  const welRef = useRef();
  welRef.current = wel;

  let { owner } = useParams();

  const retrieveWel = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    WelDataService.getAll(target)
      .then((response) => {
        // normalize common backend shapes into an array
        const payload = response?.data ?? response;
        const rows = payload?.data ?? payload?.wel ?? payload;
        setWel(Array.isArray(rows) ? rows : (rows ? [rows] : []));
      })
      .catch((e) => {
        console.error("WelList.retrieveWel error:", e?.response?.status, e?.response?.data || e?.message || e);
        setWel([]);
      });
  }, [owner]);

  const navigate = useNavigate();
  useEffect(() => {
    retrieveWel();
  }, [retrieveWel]);

  const deleteWel = useCallback((rowIndex) => {
    const id = welRef.current[rowIndex].id || welRef.current[rowIndex]._id;
    WelDataService.remove(id)
      .then(() => {
        if (props?.history?.push) props.history.push("dashboard/wel");
        const newWel = [...welRef.current];
        newWel.splice(rowIndex, 1);
        setWel(newWel);
      })
      .catch((e) => {
        console.error("deleteWel error:", e?.response?.status || e?.message || e);
      });
  }, [props.history]);

  // wrappers for TransactionTable (accept row objects)
  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/wel/${id}`);
  }, [props.history]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/wel/edit/${id}`);
  }, [props.history]);

  const handleDeleteRow = useCallback((row) => {
    const idx = welRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteWel(idx);
  }, [deleteWel]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={wel}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>

      <div className="col-md-8">
        <Link to={`/dashboard/wel/add/${owner || ""}`}>
           <button className="btn btn-sm btn-danger">Add Welfare Transaction</button>
        </Link>
      </div>
    </div>
  );
};

export default WelList;
